export const organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.hedvig.com#organization',
  name: 'Hedvig',
  alternateName: 'Hedvig Försäkring',
  legalName: 'Hedvig Försäkring AB',
  url: 'https://www.hedvig.com',
  logo: 'https://www.hedvig.com/apple-touch-icon.png',
  foundingDate: '2017',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    telephone: '+46-10-4599200',
    areaServed: 'SE',
    availableLanguage: ['sv', 'en'],
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Tulegatan 2A',
    postalCode: '113 58',
    addressLocality: 'Stockholm',
    addressCountry: 'SE',
  },
  sameAs: [
    'https://se.linkedin.com/company/hedvig',
    'https://www.instagram.com/hedvig/',
    'https://www.facebook.com/hedviginsurance',
    'https://www.youtube.com/@hedvig3015',
  ],
}

export const BUSINESS_REGISTRATION_NUMBER = '559245-5223'
